module.exports = __webpack_public_path__ + "img/MC.9c37bc9e.svg";